import React from 'react';
import { trades } from '../data/site';

/**
 * Continuous trade ticker: a nod to the scrolling partner strips
 * already used across the three company sites.
 */
export default function Marquee() {
    const lane = [...trades, ...trades];

    return (
        <div className="marquee" aria-hidden="true">
            <div className="marquee__track">
                {lane.map((trade, i) => (
                    <span className="marquee__item" key={`${trade}-${i}`}>
                        {trade}
                        <span className="marquee__sep" />
                    </span>
                ))}
            </div>
        </div>
    );
}
